"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = __importDefault(require("../base"));
var v0_6_1 = require("../generated/contract-types/factories/v0.6");
var utils_1 = require("../utils");
var AntePool = function (config, poolAddress) {
    base_1.default.call(this, config, v0_6_1.AntePoolLogic__factory);
    this.poolAddress = poolAddress;
};
AntePool.prototype = Object.create(base_1.default.prototype);
// Getters
AntePool.prototype.getTestAddress = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.anteTest();
};
AntePool.prototype.getDecayRate = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.decayRate();
};
AntePool.prototype.getChallengerPayoutRatio = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.challengerPayoutRatio();
};
AntePool.prototype.getTestAuthorRewardRate = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.testAuthorRewardRate();
};
AntePool.prototype.getTestAuthorRewardRate = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.getTestAuthorReward();
};
AntePool.prototype.getStakingDetails = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.stakingInfo();
};
AntePool.prototype.getChallengerDetails = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.challengerInfo();
};
AntePool.prototype.getEligibilityInfo = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.eligibilityInfo();
};
AntePool.prototype.getTotalPendingWithdraw = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.getTotalPendingWithdraw();
};
AntePool.prototype.getFailedBlock = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.failedBlock();
};
AntePool.prototype.getFailedTimestamp = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.failedTimestamp();
};
AntePool.prototype.getChallengerInfo = function (address) {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.getChallengerInfo(address);
};
AntePool.prototype.getUserStoredBalance = function (address, isChallenger) {
    if (isChallenger === void 0) { isChallenger = false; }
    var contract = this.getContractInstance(this.poolAddress);
    return contract.getStoredBalance(address, isChallenger);
};
AntePool.prototype.getPendingWithdrawAmount = function (address) {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.getPendingWithdrawAmount(address);
};
AntePool.prototype.getPendingFailure = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.pendingFailure();
};
AntePool.prototype.getTimesVerified = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.numTimesVerified();
};
AntePool.prototype.getLastUpdateTimestamp = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.lastUpdateTimestamp();
};
AntePool.prototype.getLastVerifiedBlock = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.lastVerifiedBlock();
};
AntePool.prototype.getLastVerifiedTimestamp = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.lastVerifiedTimestamp();
};
AntePool.prototype.getVerifier = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.verifier();
};
AntePool.prototype.getUserStartAmount = function (address, isChallenger) {
    if (isChallenger === void 0) { isChallenger = false; }
    var contract = this.getContractInstance(this.poolAddress);
    return contract.getUserStartAmount(address, isChallenger);
};
AntePool.prototype.getUserStartDecayMultiplier = function (address, isChallenger) {
    if (isChallenger === void 0) { isChallenger = false; }
    var contract = this.getContractInstance(this.poolAddress);
    return contract.getUserStartDecayMultiplier(address, isChallenger);
};
AntePool.prototype.getVerifierBounty = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.getVerifierBounty();
};
AntePool.prototype.getCheckTestAllowedBlock = function (address) {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.getCheckTestAllowedBlock(address);
};
AntePool.prototype.getPendingWithdrawAllowedTime = function (address) {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.getPendingWithdrawAllowedTime(address);
};
AntePool.prototype.getChallengerPayout = function (address) {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.getChallengerPayout(address);
};
AntePool.prototype.getUnstakeAllowedTime = function (address) {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.getUnstakeAllowedTime(address);
};
AntePool.prototype.getTotalChallengerEligibleBalance = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.getTotalChallengerEligibleBalance();
};
AntePool.prototype.getTotalChallengerStaked = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.getTotalChallengerStaked();
};
AntePool.prototype.getTotalStaked = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.getTotalStaked();
};
AntePool.prototype.getToken = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.token();
};
AntePool.prototype.getWithdrawInfo = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.withdrawInfo();
};
AntePool.prototype.getMinChallengerStake = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.minChallengerStake();
};
AntePool.prototype.getMinSupporterStake = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.minSupporterStake();
};
AntePool.prototype.getTotalPaidOut = function () {
    var contract = this.getContractInstance(this.poolAddress);
    return contract.totalPaidOut();
};
// Transactions
AntePool.prototype.stake = function (args, signer, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var contract, amount, commitTime, tx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    contract = this.getContractInstance(this.poolAddress);
                    amount = args.amount, commitTime = args.commitTime;
                    return [4 /*yield*/, contract.populateTransaction.stake(amount, commitTime, options)];
                case 1:
                    tx = _a.sent();
                    if (!((options === null || options === void 0 ? void 0 : options.gasLimit) === undefined)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, utils_1.populateTransactionGas)(tx, this.config, signer, 'stake')];
                case 2:
                    tx = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, (0, utils_1.executePopulatedTransaction)(tx, signer)];
            }
        });
    });
};
AntePool.prototype.extendStakeLock = function (args, signer, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var contract, additionalTime, tx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    contract = this.getContractInstance(this.poolAddress);
                    additionalTime = args.additionalTime;
                    return [4 /*yield*/, contract.populateTransaction.extendStakeLock(additionalTime, options)];
                case 1:
                    tx = _a.sent();
                    if (!((options === null || options === void 0 ? void 0 : options.gasLimit) === undefined)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, utils_1.populateTransactionGas)(tx, this.config, signer, 'extendStakeLock')];
                case 2:
                    tx = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, (0, utils_1.executePopulatedTransaction)(tx, signer)];
            }
        });
    });
};
AntePool.prototype.registerChallenge = function (args, signer, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var contract, amount, tx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    contract = this.getContractInstance(this.poolAddress);
                    amount = args.amount;
                    return [4 /*yield*/, contract.populateTransaction.registerChallenge(amount, options)];
                case 1:
                    tx = _a.sent();
                    if (!((options === null || options === void 0 ? void 0 : options.gasLimit) === undefined)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, utils_1.populateTransactionGas)(tx, this.config, signer, 'registerChallenge')];
                case 2:
                    tx = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, (0, utils_1.executePopulatedTransaction)(tx, signer)];
            }
        });
    });
};
AntePool.prototype.confirmChallenge = function (signer, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var contract, tx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    contract = this.getContractInstance(this.poolAddress);
                    return [4 /*yield*/, contract.populateTransaction.confirmChallenge(options)];
                case 1:
                    tx = _a.sent();
                    if (!((options === null || options === void 0 ? void 0 : options.gasLimit) === undefined)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, utils_1.populateTransactionGas)(tx, this.config, signer, 'confirmChallenge')];
                case 2:
                    tx = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, (0, utils_1.executePopulatedTransaction)(tx, signer)];
            }
        });
    });
};
AntePool.prototype.unstakeAll = function (args, signer, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var contract, isChallenger, tx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    contract = this.getContractInstance(this.poolAddress);
                    isChallenger = args.isChallenger;
                    return [4 /*yield*/, contract.populateTransaction.unstakeAll(isChallenger, options)];
                case 1:
                    tx = _a.sent();
                    if (!((options === null || options === void 0 ? void 0 : options.gasLimit) === undefined)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, utils_1.populateTransactionGas)(tx, this.config, signer, 'unstakeAll')];
                case 2:
                    tx = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, (0, utils_1.executePopulatedTransaction)(tx, signer)];
            }
        });
    });
};
AntePool.prototype.claim = function (signer, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var contract, tx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    contract = this.getContractInstance(this.poolAddress);
                    return [4 /*yield*/, contract.populateTransaction.claim(options)];
                case 1:
                    tx = _a.sent();
                    if (!((options === null || options === void 0 ? void 0 : options.gasLimit) === undefined)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, utils_1.populateTransactionGas)(tx, this.config, signer, 'claim')];
                case 2:
                    tx = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, (0, utils_1.executePopulatedTransaction)(tx, signer)];
            }
        });
    });
};
AntePool.prototype.claimReward = function (signer, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var contract, tx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    contract = this.getContractInstance(this.poolAddress);
                    return [4 /*yield*/, contract.populateTransaction.claimReward(options)];
                case 1:
                    tx = _a.sent();
                    if (!((options === null || options === void 0 ? void 0 : options.gasLimit) === undefined)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, utils_1.populateTransactionGas)(tx, this.config, signer, 'claimReward')];
                case 2:
                    tx = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, (0, utils_1.executePopulatedTransaction)(tx, signer)];
            }
        });
    });
};
AntePool.prototype.checkTest = function (signer, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var contract, tx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    contract = this.getContractInstance(this.poolAddress);
                    return [4 /*yield*/, contract.populateTransaction.checkTest(options)];
                case 1:
                    tx = _a.sent();
                    if (!((options === null || options === void 0 ? void 0 : options.gasLimit) === undefined)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, utils_1.populateTransactionGas)(tx, this.config, signer, 'checkTest')];
                case 2:
                    tx = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, (0, utils_1.executePopulatedTransaction)(tx, signer)];
            }
        });
    });
};
AntePool.prototype.checkTestWithState = function (args, signer, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var contract, tx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    contract = this.getContractInstance(this.poolAddress);
                    return [4 /*yield*/, contract.populateTransaction.checkTestWithState(args.state, options)];
                case 1:
                    tx = _a.sent();
                    if (!((options === null || options === void 0 ? void 0 : options.gasLimit) === undefined)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, utils_1.populateTransactionGas)(tx, this.config, signer, 'checkTestWithState')];
                case 2:
                    tx = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, (0, utils_1.executePopulatedTransaction)(tx, signer)];
            }
        });
    });
};
AntePool.prototype.withdrawStake = function (signer, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var contract, tx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    contract = this.getContractInstance(this.poolAddress);
                    return [4 /*yield*/, contract.populateTransaction.withdrawStake(options)];
                case 1:
                    tx = _a.sent();
                    if (!((options === null || options === void 0 ? void 0 : options.gasLimit) === undefined)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, utils_1.populateTransactionGas)(tx, this.config, signer, 'withdrawStake')];
                case 2:
                    tx = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, (0, utils_1.executePopulatedTransaction)(tx, signer)];
            }
        });
    });
};
AntePool.prototype.cancelPendingWithdraw = function (signer, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var contract, tx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    contract = this.getContractInstance(this.poolAddress);
                    return [4 /*yield*/, contract.populateTransaction.cancelPendingWithdraw(options)];
                case 1:
                    tx = _a.sent();
                    if (!((options === null || options === void 0 ? void 0 : options.gasLimit) === undefined)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, utils_1.populateTransactionGas)(tx, this.config, signer, 'cancelPendingWithdraw')];
                case 2:
                    tx = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, (0, utils_1.executePopulatedTransaction)(tx, signer)];
            }
        });
    });
};
exports.default = AntePool;
